import { useQueryClient } from '@tanstack/vue-query';
import { ValuesEnum } from '@/enums/values.enum';
import useStorageService from '@/shared/composables/useStorageService';
import { Preferences } from '@capacitor/preferences';

const useQueryCacheHelper = () => {
	const queryClient = useQueryClient();
	const { remove } = useStorageService();

	// Let's start out by centralizing the removeCaches function
	// so that we make it easier to actually remove the caches later by properly scoping them by user id
	// should we want to
	const removeCaches = async () => {
		// Remove caches
		const keysToRemove = [
			// 'registrationForm',
			// 'event',
			// 'events',
			// 'eventTicketTypes',
			// 'eventTickets',
			// 'map',
			// 'maps',
			// 'post',
			'userProfile',
			'userProfileDetail',
			// 'rfidTags',
			// 'rfidWallet',
			// 'rfidSearch',
			// 'tableSpotProductCategories',
			// 'tableSpotProducts',
			// 'autoOpenSelfOrder',
			// 'shop',
			// 'shopCategory',
			// 'shopCategoriesWithProducts',
			// 'tagsList',
			// 'timeTable',
			// 'timeTables',
			// 'wallets',
			// 'walletRefundRequests',
			// 'userWallet',
			// 'walletTransactions',
			// 'walletTransaction',
			// 'walletQrCode',
			// 'refundInfo',
			// 'friends',
		];

		// TODO: we are not actually cancelling any calls that are already in progress
		// to do that we would have to call cancelQueries before removing the queries
		keysToRemove.forEach((key: string) => queryClient.removeQueries({ queryKey: [key] }));
	};

	const removeCachesForSoftUpdate = async () => {
		// Remove caches
		const keysToRemove = [ValuesEnum.StoreCacheTimestamps];

		keysToRemove.forEach((key: string) => remove(key));

		// Clear cached logo and background images
		// This prevents showing wrong tenant's logo after soft update
		try {
			const allKeysResult = await Preferences.keys();
			const allKeys = allKeysResult.keys || [];

			// Filter for logo and background cache keys (both old format and new tenant-specific format)
			const imageKeysToRemove = allKeys.filter((key) => {
				return key.startsWith('logo-') || key.startsWith('background-');
			});

			// Remove all cached logo and background images
			for (const key of imageKeysToRemove) {
				await Preferences.remove({ key });
				console.log(`[SoftUpdate] Removed cached image: ${key}`);
			}

			if (imageKeysToRemove.length > 0) {
				console.log(`[SoftUpdate] Cleared ${imageKeysToRemove.length} cached logo/background images`);
			}
		} catch (error) {
			console.error('[SoftUpdate] Error clearing cached images:', error);
		}
	};

	// const authStore = useAuthStore();
	// const id = authStore.user.token;
	// console.log('id', id, authStore.guestOrUserId);
	//
	// // authStore.$subscribe((mutation, state) => {
	// // 	state.user.id
	// //
	// // })
	// watch(
	// 	() => authStore.guestOrUserId,
	// 	(newId, oldId) => {
	// 		console.log('id watcher called', { newId, oldId });
	// 		if (newId === oldId) return;
	// 		console.log(`New user id: ${newId}. Clearing queries for ${oldId}`);
	// 		queryClient.cancelQueries({ queryKey: [oldId] });
	// 		queryClient.removeQueries({ queryKey: [oldId] });
	// 	},
	// 	// { immediate: true },
	// );

	return {
		getScopedQueryKey: (scope: string | Array<string>) => {
			const key = Array.isArray(scope) ? scope : [scope];
			// return ['user', id, ...key];
			return key;
		},
		removeCaches,
		removeCachesForSoftUpdate,
	};
};

export default useQueryCacheHelper;
